import { useState } from "react";

const WHATSAPP_NUMBER = "256742181804";
const WHATSAPP_MESSAGE = "Hello! I'd like to learn more about El Hai Pentecostal Ministries.";

export default function FloatingWhatsApp() {
  const [hovered, setHovered] = useState(false);

  const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;

  return (
    <div className="fixed bottom-6 right-6 z-50 flex items-center gap-3">
      {hovered && (
        <div className="bg-white text-gray-800 text-sm font-medium px-4 py-2 rounded-full shadow-lg whitespace-nowrap border border-gray-100 animate-fade-in">
          Chat with us on WhatsApp
        </div>
      )}
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        aria-label="Chat with us on WhatsApp"
        className="w-14 h-14 flex items-center justify-center rounded-full shadow-lg cursor-pointer transition-transform duration-200 hover:scale-110"
        style={{ backgroundColor: "#25D366" }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 32 32"
          width="30"
          height="30"
          fill="white"
        >
          <path d="M16.003 2.667C8.637 2.667 2.667 8.637 2.667 16c0 2.363.635 4.674 1.84 6.693L2.667 29.333l6.822-1.788A13.276 13.276 0 0016.003 29.333c7.363 0 13.33-5.97 13.33-13.333 0-7.363-5.967-13.333-13.33-13.333zm0 24.267a11.006 11.006 0 01-5.617-1.537l-.402-.238-4.048 1.062 1.08-3.944-.262-.413A10.964 10.964 0 015.003 16c0-6.065 4.935-11 11-11s11 4.935 11 11-4.935 11-11 11zm6.04-8.233c-.33-.165-1.953-.963-2.256-1.073-.303-.11-.523-.165-.743.165-.22.33-.853 1.073-1.046 1.293-.193.22-.386.247-.716.082-.33-.165-1.393-.513-2.653-1.638-.98-.875-1.642-1.956-1.834-2.286-.193-.33-.02-.508.145-.672.149-.148.33-.386.495-.578.165-.193.22-.33.33-.55.11-.22.055-.413-.028-.578-.082-.165-.743-1.793-.018-1.018l-.017-.017c-.247-.606-.506-.523-.7-.533-.18-.009-.386-.011-.594-.011-.207 0-.55.077-.838.385-.288.308-1.1 1.073-1.1 2.618 0 1.545 1.126 3.038 1.283 3.248.157.21 2.216 3.384 5.368 4.617.75.288 1.336.46 1.792.589.753.213 1.438.183 1.98.111.604-.08 1.953-.799 2.229-1.57.275-.77.275-1.43.193-1.57-.083-.138-.303-.22-.633-.385z" />
        </svg>
      </a>
    </div>
  );
}
